import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="availability-all-day-toggle"
export default class extends Controller {
  static targets = ["allDay", "finishTime", "startTime"]
  connect() {
  }

  clearAllDay(event) {
    this.allDayTarget.checked = false;
  }

  setAllDayTimes(event) {
    if (this.allDayTarget.checked) {
      this.startHourTarget.value = "00";
      this.startMinuteTarget.value = "00";
      this.finishHourTarget.value = "23";
      this.finishMinuteTarget.value = "59";
    }
  }

  get startHourTarget() {
    return this.startTimeTarget.querySelector('select[id$="_4i"]');
  }

  get startMinuteTarget() {
    return this.startTimeTarget.querySelector('select[id$="_5i"]');
  }

  get finishHourTarget() {
    return this.finishTimeTarget.querySelector('select[id$="_4i"]');
  }

  get finishMinuteTarget() {
    return this.finishTimeTarget.querySelector('select[id$="_5i"]');
  }
}
